// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"MassMailingItemsList_ProseMirror__2dirw","statusError":"MassMailingItemsList_statusError__34CQH"};